import { FC, useMemo, useState } from 'react';
import { isArray, refactorPermissions } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import V2Title from '@/common/components/Feedback/V2Title';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import V2Operate from '@/common/components/Others/V2Operate';
import TaskChangeModal from '@/common/components/business/ExpandStore/TaskDetailCommon/TaskChangeModal';
import { TaskChange, TaskStatusTagStyle } from '@/common/components/business/ExpandStore/ts-config';
import { useBigdataFn } from '@/common/utils/bigdata';
import styles from '@/common/components/business/ExpandStore/TaskDetailDrawer/index.module.less';

/** 拓店任务：加盟（三津汤包）-详情-顶部操作 */
const TaskDetailHeader: FC<{
  detail: any;
  hideOperate?: boolean;
  onRefresh?: Function;
}> = ({
  detail,
  hideOperate = false,
  onRefresh,
}) => {
  const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const [changeVisible, setChangeVisible] = useState<boolean>(false); // 异动申请弹框

  const operateList = useMemo(() => {
    return [
      /** 是否展示开发异动按钮，有启用异动、未提交异动、且有异动权限时展示 */
      {
        name: '开发异动', event: 'taskChange', type: 'default',
        visible: !hideOperate && detail && detail.taskChangeApprovalStatus === TaskChange.None && isArray(detail.buttons) && !!detail.buttons.length && detail.taskChangeButton === 1,
      },
      /** 是否展示开发异动审批中按钮，异动审批中时展示 */
      {
        name: '开发异动中', event: 'taskApproving', type: 'default',
        visible: detail && detail.taskChangeApprovalStatus === TaskChange.Approving
      },
    ].filter((item) => item.visible);
  }, [detail, hideOperate]);

  const methods = useMethods({
    /** 点击开发异动 */
    handleTaskChange() {
      // 申请异动弹框
      setChangeVisible(true);
      bigdataFn('a96efd64-8c31-496e-85c5-073a84aae7a2', '拓店任务详情-开发异动', '点击了拓店任务详情-开发异动', { op_block: '拓店任务管理', op_event: ``, });
    },
    /** 点击开发异动中 */
    handleTaskApproving() {
      V2Message.warning('异动申请中，在我发起的审批中查看');
    },
    handleOperateClick(button: any) {
      methods[button.func] && methods[button.func]();
    },
  });

  return <div className={styles.taskDetailHeader}>
    <V2Title
      extra={<V2Operate
        showBtnCount={4}
        operateList={refactorPermissions(operateList)}
        onClick={methods.handleOperateClick}
      />}
    >
      <div className={styles.titleWrapper}>
        <span className='fs-20 bold c-222'>{detail?.name}</span>
        <div
          className={styles.statusBox}
          style={{
            ...TaskStatusTagStyle[detail?.status]
          }}
        >{detail?.statusName}</div>
      </div>
    </V2Title>

    {/* 发起异动 */}
    <TaskChangeModal
      visible={changeVisible}
      setVisible={setChangeVisible}
      detail={detail}
      onRefresh={onRefresh}
    />
  </div>;
};

export default TaskDetailHeader;
